<template>
	<div>
		<div class="modal fade" id="modalCreateVacina" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div
					class="modal-content modalContent-criarVacina"
					v-if="
						!this.data.creationCPF &&
						!this.data.creationShip &&
						!this.data.creationPassaport &&
						!this.data.creationType
					"
				>
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							CRIAR VACINA
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>CPF</span>
							<div class="add-more-section">
								<input
									type="text"
									v-model="data.CPF"
									class="form-control"
									v-on:change="handleChangeCPF()"
									ref="cpf"
									id="cpf"
									v-mask="'###.###.###-##'"
									placeholder="999.999.999-99"
								/>
								<aBtn
									@click="handleToggleCreationCPF()"
									text=""
									icon="plus"
									size="sm"
									type="success"
								/>
							</div>
						</div>

						<div class="col-sm-5">
							<span>NOME</span>
							<input
								readonly
								type="text"
								v-model="data.nome"
								class="form-control"
								placeholder="NOME"
							/>
						</div>

						<div class="col-sm-4">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-3">
							<span>Marca da Vacina</span>
							<select
								style="text-transform: uppercase"
								v-model="data.marca"
								class="form-control"
							>
								<option
									v-for="(lab, index) in laboratory"
									:key="index"
									:value="lab"
								>
									{{ lab }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>TIPO DE VACINA</span>

							<div class="add-more-section">
								<select
									v-model="data.tipo_vacina"
									class="form-control"
								>
									<option
										style="text-transform: uppercase"
										v-for="(teste, index) in tipo_vacina"
										:key="index"
										:value="teste.nome_tipo_vacina"
										:id="teste.nome_tipo_vacina"
									>
										{{ teste.nome_tipo_vacina }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-3">
							<span>DATA</span>

							<input
								class="form-control"
								type="date"
								v-model="data.data_vacina"
								v-on:change="
									handleChangeDataFormat(
										$event,
										'data_vacina'
									)
								"
								id="dataImpressa"
							/>
						</div>

						<div class="col-sm-3">
							<span>VENC. VACINA</span>

							<input
								class="form-control"
								type="date"
								v-model="data.vencimento_vacina"
								v-on:change="
									handleChangeDataFormat(
										$event,
										'vencimento_vacina'
									)
								"
								id="vencimento"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>
							<div>
								<label
									class="form-control--no-padding"
									for="inputImagemVacina"
								>
									<div class="btn-upload-image">
										Anexar imagem
										<i class="fa fa-upload"></i>
									</div>
									<!-- v-model="data.anexo" -->
									<div class="file">
										<input
											type="file"
											multiple="false"
											class="inputImagemVacina"
											accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .svg, .pdf, .tiff|image/*"
											v-on:change="
												handleUploadImage($event)
											"
											id="inputImagemVacina"
										/>
									</div>
								</label>
								<aBtn
									action="private-save-vacinas"
									@click="save"
									text="Salvar"
									icon="save"
									type="primary"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-content" v-if="this.data.creationCPF">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-4">
							<span>CPF</span>
							<input
								class="form-control"
								type="text"
								v-model="data.CPF"
								v-on:change="handleChangeCPF()"
								ref="cpf"
								id="cpf"
								v-mask="'###.###.###-##'"
							/>
						</div>

						<div class="col-sm-8">
							<span>NOME</span>
							<input
								class="form-control"
								type="text"
								v-model="data.nome"
								ref="nome"
								id="nome"
							/>
						</div>

						<div class="col-sm-6">
							<span>RG/PASSAPORTE</span>
							<input
								class="form-control"
								type="number"
								v-model="data.RG"
								ref="rg"
								id="rg"
							/>
						</div>

						<div class="col-sm-3">
							<span>Cargo</span>
							<select v-model="data.cargos" class="form-control">
								<option
									v-for="(cargo, index) in cargos"
									:key="index"
									:value="cargo.nome_cargo"
								>
									{{ cargo.nome_cargo }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-5">
							<span>Empresa</span>
							<select v-model="data.empresa" class="form-control">
								<option
									v-for="(empresa, index) in empresas"
									:key="index"
									:value="empresa.razao_social"
								>
									{{ empresa.razao_social }}
								</option>
							</select>
						</div>

						<div class="col-sm-4">
							<span>Data de Nascimento</span>
							<input
								type="text"
								v-model="data.dataNasc"
								class="form-control"
								v-mask="'##/##/####'"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationCPF()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="saveCpf"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

id precisa existir para poder ocorrer a criação

*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	import { mask } from 'vue-the-mask';
	// md-autocomplete MdAutocomplete
	import { MdAutocomplete } from 'vue-material/dist/components';

	let reset = {
		empresa: '',
		nome_vacina: '',
		colaborador: '',
		cargo: '',
		nome: '',
		navio: '',
		frota: '',
		idade: 0,
		anexo: ``,
		status: '',
		statusMask: "'##%'",
		data_vacina: ``,
		dataEnviada: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		vencimento_vacina: ``,
		validade: '',
		marca: '',
		creationCPF: false,
		creationShip: false,
		creationType: false,
		creationPassaport: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
		passaport: '',
		control: '',
		tipo_vacina: '',
	};

	export default {
		name: 'modalCriarVacina',
		components: { aBox, aBtn, mask },
		data() {
			return {
				data: {
					moment: moment,
					...clone(reset),
				},
				test: null,
				pessoas: [],

				cargos: [
					{
						navio: 'Não há dados',
					},
				],

				estados: null,
				municipios: null,
				tipo_vacina: [
					{
						nome_tipo_vacina: 'Nenhuma vacina cadastrada!',
					},
				],

				laboratory: ['Astrazeneca', 'Coronavac', 'Janssen', 'Pfizer'],

				loading: false,
			};
		},
		methods: {
			handleUploadImage(e) {
				const file = e.target.files[0];
				const fileName = file.name.replace(/ /g, '');
				var blob = file.slice(0, file.size, file.type);
				const updatedFile = new File([blob], fileName, {
					type: file.type,
				});
				this.uploadImage(updatedFile);
			},

			async uploadImage(file) {
				const backendUrl = 'http://viamed.ddns.net:3000';
				const formData = new FormData();
				formData.append('file', file);
				const uploadedImageUrl = await axios
					.post(`${backendUrl}/upload`, formData, {
						headers: {
							Accept: 'application/json',
							'Content-Type': 'multipart/form-data',
							'Access-Control-Allow-Origin': '*',
						},
					})
					.then(() => `${backendUrl}/uploads/${file.name}`);
				this.data.anexo = uploadedImageUrl;
			},

			handleChangeDataFormat(e, dateModel) {
				const stringValue = e.target.value;
				const dateStringParsed =
					moment(stringValue).format('YYYY-MM-DD');
				this.data[dateModel] = dateStringParsed;
			},

			handleChangeCPF() {
				const cpf = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				if (cpf.length < 9) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `cpf=${cpf}`,
				};

				WBS.send('private-read-pessoas', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('CPF não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleLoadTiposDeVacinas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-tipos_de_vacina', testParms, (resp) => {
					const unorderedTipoVacina = resp.data.table;
					if (unorderedTipoVacina.length <= 0) return false;
					this.tipo_vacina = unorderedTipoVacina.sort((a, b) =>
						a.nome_tipo_vacina.localeCompare(b.tipo_vacina)
					); //order the object alphabetically

					const lastTipoDeVacina =
						this.tipo_vacina[this.tipo_vacina.length - 1];

					this.data.tipo_vacina = lastTipoDeVacina.tipo_vacina;
				});
			},

			handleToggleCreationCPF() {
				this.data.creationCPF = !this.data.creationCPF;
			},

			handleToggleCreationType() {
				this.data.creationType = !this.data.creationType;
			},

			handleToggleCreationPassaport() {
				this.data.creationPassaport = !this.data.creationPassaport;
			},

			async open(data = null) {
				this.data = clone(reset);
				$('#modalCreateVacina').modal('show');
			},

			save() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');
				this.data.control = `${this.data.CPF} ${this.data.data}`;
				this.data.data_vacina = moment(this.data.data_vacina).format(
					'YYYY-MM-DD'
				);
				this.data.vencimento_vacina = moment(
					this.data.vencimento_vacina
				).format('YYYY-MM-DD');
				WBS.send('private-save-vacinas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Vacina criada com sucesso!');
						this.$emit('update');
						$('#modalCreateVacina').modal('hide');
						window.location.reload();
					} else {
						toastr.error(resp.msgs[0]);
						// console.log(resp)
						// console.log(this.data)
					}
				});
			},

			saveCpf() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationCPF();
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					const unorderednavios = resp.data.table;
					this.navios = unorderednavios.sort((a, b) =>
						a.navio.localeCompare(b.navio)
					); //order the object alphabetically

					if (this.navios.length - 1 > 0) {
						const lastNavio = this.navios[this.navios.length - 1];
						this.data.navio = lastNavio.navio;
					}
				});
			},

			handleLoadCargos() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-cargos', testParms, (resp) => {
					const unorderedCargos = resp.data.table;
					this.cargos = unorderedCargos.sort((a, b) =>
						a.nome_cargo.localeCompare(b.nome_cargo)
					); //order the object alphabetically

					// console.log(this.cargos)
				});
			},

			handleLoadLocalDeExames() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-local_de_exame', testParms, (resp) => {
					const unorderedLocalDoteste = resp.data.table;
					this.localDoteste = unorderedLocalDoteste.sort((a, b) =>
						a.nome_local_exame.localeCompare(b.nome_local_exame)
					); //order the object alphabetically
				});
			},

			handleLoadEmpresas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
					filter: `regiao='OFF'`,
				};

				WBS.send('private-read-customers', testParms, (resp) => {
					const unorderedEmpresas = resp.data.table;
					this.empresas = unorderedEmpresas.sort((a, b) =>
						a.razao_social.localeCompare(b.razao_social)
					); //order the object alphabetically
				});
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
			this.handleLoadTiposDeVacinas();
			this.handleLoadEmpresas();
			this.handleLoadCargos();
			this.handleLoadLocalDeExames();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}

	/*
.table{
	overflow
}
*/

	.md-autocomplete + strong {
		margin-top: 36px;
		display: block;
	}

	.md-autocomplete-items {
		z-index: 99 !important;
		background: white !important;
		position: relative !important;
		top: 85% !important;
	}

	.md-menu-content {
		min-width: 33% !important;
		background: white !important;
		/*
	top: 430px !important;
	*/
		z-index: 99999 !important;
	}

	.md-list {
		width: 100% !important;
		background: white;
		top: 430px !important;
		z-index: 99999;
	}

	.col--featured {
		/*
	*/
		height: 54px !important;
	}

	.modalContent-criarVacina {
		width: 60%;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/modalCriarVacina.vue